var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5118 2.48816L14.0421 1.95783V1.95783L13.5118 2.48816ZM4.33333 14.0237V14.7737C4.53225 14.7737 4.72301 14.6946 4.86366 14.554L4.33333 14.0237ZM2 14.0237H1.25C1.25 14.4379 1.58579 14.7737 2 14.7737V14.0237ZM2 11.6429L1.46967 11.1126C1.32902 11.2533 1.25 11.444 1.25 11.6429H2ZM11.6851 3.01849C12.0431 2.6605 12.6235 2.6605 12.9815 3.01849L14.0421 1.95783C13.0984 1.01406 11.5682 1.01406 10.6245 1.95783L11.6851 3.01849ZM12.9815 3.01849C13.3395 3.37647 13.3395 3.95687 12.9815 4.31485L14.0421 5.37551C14.9859 4.43174 14.9859 2.90159 14.0421 1.95783L12.9815 3.01849ZM12.9815 4.31485L3.803 13.4933L4.86366 14.554L14.0421 5.37551L12.9815 4.31485ZM4.33333 13.2737H2V14.7737H4.33333V13.2737ZM10.6245 1.95783L1.46967 11.1126L2.53033 12.1733L11.6851 3.01849L10.6245 1.95783ZM1.25 11.6429V14.0237H2.75V11.6429H1.25ZM9.62445 4.01849L11.9815 6.37551L13.0421 5.31485L10.6851 2.95783L9.62445 4.01849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.e71aafa7e1dd965d58f44912f83ab968.svg";
export { ForwardRef as ReactComponent };